module.exports = __webpack_public_path__ + "img/公司概况.99db9ebc.png";